import { useQuery } from '@tanstack/react-query';
import { Box, TextField } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { getMasterEquipmentPartsByQuery } from 'components/axios/equipmentCategoryAxios';
import { Controller } from 'react-hook-form';
import CustomFormSelect from 'components/select/CustomFormSelect';
import { Grid4 } from './CommonModule';
import { t } from 'i18next';

export default function MaintenanceInputPartsRow({ 
  item, 
  status=null,
  control,
  register, 
  componentOptions, 
  locationOptions, 
  onPartChange, 
  onDelete 
}) {
// console.log(item)
  // 💡 [핵심] part.id가 0이 아니라면 서버에서 들고 온 '기존 데이터'로 판단합니다.
  const isExistingData = item.part && item.part.id !== 0;

  // 🚀 [행별 독립 API] 해당 행의 componentId가 선택되었을 때만 대상자재를 가져옴
  const { data: materialOptionDatas = [], isLoading: isMaterialLoading } = useQuery({
    queryKey: ['materialList', item.part.componentId],
    queryFn: () => getMasterEquipmentPartsByQuery({ "equipmentCtgr.id": item.part.componentId, size:100 }),
    // 💡 수정 모드에서 기존 데이터라면 이미 자재 목록이 확정되었으므로 API를 호출 할 필요가 없습니다. (선택 사항)
    // enabled: !!item.part.componentId && !isExistingData,
    enabled: !!item.part.componentId, // ⭐ 이 행의 componentId가 채워졌을 때만 호출해라!
  });
  const materialOptions = materialOptionDatas?._embedded?.masterEquipmentParts|| [];

  return (
    <Grid4 sx={{ mb: 1 }}>
        {/* 1. 설비구성부 */}
        <Controller
            sx={{ m: 1, minWidth: "90%" }}
            // aria-invalid={!isDirty ? undefined : errors.componentId ? "true" : "false"}
            control={control}
            name={`inputParts[${item.id}].part.componentId`} // react-hook-form 고유 네임 스페이스 권장
            value={item.part.componentId}
            render={({ field: {name} }) => (
            <CustomFormSelect
                style={{ minWidth: '80%' }}
                label={t('message.common.subtitle.equipment.component')}
                // 💡 기존 데이터라면 셀렉트 박스 비활성화
                readOnly={isExistingData}
                register={register}
                name={name}
                // requiredMessage={"설비구성부를 선택하십시오."}
                defaultValue={item.part.componentId || ''}
                onChange={(e) => onPartChange(item.id, "componentId", e.target.value)}
                list={componentOptions}
            />
            )}
        />
        {/* 2. 구성부위치 */}
        <Controller
            sx={{ m: 1, minWidth: "90%" }}
            // aria-invalid={!isDirty ? undefined : errors.componentLocationId ? "true" : "false"}
            control={control}
            name={`inputParts[${item.id}].part.componentLocationId`} // react-hook-form 고유 네임 스페이스 권장
            value={item.part.componentLocationId}
            render={({ field: {name} }) => (
            <CustomFormSelect
                style={{ minWidth: '80%' }}
                label={t('message.common.subtitle.component.position')}
                // 💡 기존 데이터라면 셀렉트 박스 비활성화
                readOnly={isExistingData}
                register={register}
                name={name}
                // requiredMessage={"구성부위치를 선택하십시오."}
                defaultValue={item.part.componentLocationId || ''}
                onChange={(e) => onPartChange(item.id, "componentLocationId", e.target.value)}
                list={locationOptions}
            />
            )}
        />
        {/* 3. 대상자재 (앞의 componentId에 종속됨) */}
        <Controller
            sx={{ m: 1, minWidth: "90%" }}
            // aria-invalid={!isDirty ? undefined : errors.partId ? "true" : "false"}
            control={control}
            name={`inputParts[${item.id}].part.partId`} // react-hook-form 고유 네임 스페이스 권장
            value={item.part.partId}
            render={({ field: {name} }) => (
            <CustomFormSelect
                style={{ minWidth: '80%' }}
                label={t('message.common.subtitle.target.material')}
                // 💡 기존 데이터이거나, 신규 데이터인데 앞의 구성부가 없거나 로딩 중일 때 비활성화
                readOnly={isExistingData || !item.part.componentId || isMaterialLoading}
                // disabled={!item.part.componentId || isMaterialLoading} // 구성부가 없거나 로딩 중이면 비활성화
                register={register}
                name={name}
                // requiredMessage={"대상자재를 선택하십시오."}
                defaultValue={item.part.masterPartId || ''}
                onChange={(e) => {
                    const partId = e.target.value;
                    const partLifeSpanTime = materialOptions?.find(p=>p.id === partId)?.lifeSpanTime;
                    onPartChange(item.id, "partId", partId)
                    onPartChange(item.id, "masterPartId", partId)
                    onPartChange(item.id, "partLifeSpanTime", partLifeSpanTime)
                }}
                list={materialOptions}
            />
            )}
        />
        {/* 4. 부품명 직접입력 */}
        <Box display="flex" alignItems="center">
            <TextField
                fullWidth
                InputProps={{
                    readOnly: !(!status || status !== 'O3_C'),
                }}
                value={item.part.subPart}
                placeholder={t('message.common.subtitle.placeholder.enter.part.name.directly')}
                onChange={(e) => onPartChange(item.id, "subPart", e.target.value)}
            />

            {(!status || status !== 'O3_C') &&
            <RemoveCircleOutlineIcon
                sx={{ ml: 1, cursor: "pointer", color: "red" }}
                onClick={() => onDelete(item.id)}
            />
            }
        </Box>
    </Grid4>
  );
}